import { APIResponseType } from "../types";
import { createGetApiHook, createPostApiHook } from "./apiHooks";

const NotificationAPI = (queryParams: Record<string, any>) => {
  const queryString = queryParams
    ? new URLSearchParams(queryParams).toString()
    : "";
  return !queryString
    ? "/notification?offset=0&limit=1000"
    : `/notification?${queryString}`;
};

const markAllAsRead = "notification/mark-all-as-read";

export const useGetNotification = createGetApiHook<APIResponseType<any>, {}>(
  NotificationAPI,
);

export const useAllNotificationRead = createPostApiHook<
  {},
  {},
  APIResponseType<any>
>(markAllAsRead, {
  isFormDataMethod: false,
});

export const useSendSocketNotification = createPostApiHook<
  { event: string, data: any },
  {},
  APIResponseType<any>
>("/notification/socket", {
  isFormDataMethod: false,
});
